function getArrayRandomElement<T>(arr: Array<T>): T {
  if (arr && arr.length) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
  throw new Error("Array ist empty.");
}

export default getArrayRandomElement;
